---
demo:
  concept:
    title: |-
      LOGBOOK Konzept
    start1: |-
      LOGBOOK Konzept
    start2: |-
      Ein Logbuch ist ein chronologischer Bericht über die **Positionen eines Schiffes während eines Törns** – die Bewegung des Schiffes und die Ereignisse an Bord in Raum und Zeit.
    timelineOverview: |-
      In LOGBOOK wird die Schiffszeit in Form einer **Timeline** dargestellt.
      Die Timeline ist eine durchgehende **vertikale Timeline**, die **von oben nach unten** verläuft.

    timelineYears_title: |-
      LOGBOOK Konzept: Übersichtsmodus
    timelineYears: |-
      Die Timeline beginnt im **ersten Jahr**, für das ein Eintrag vorhanden ist, und reicht bis zum Ende des **aktuellen Jahres**. Alle **Törns** sind entlang dieser Timeline angeordnet.

    timelineYears2_title: |-
      LOGBOOK Konzept: Übersichtsmodus
    timelineYears2: |-
      Anstatt verwirrenden Blätterns zwischen Tageszeiten in analogen Logbüchern gibt es im digitalen Logbuch intuitives **Scrollen** und **Zoomen**.

    timelineYears3_title: |-
      LOGBOOK Konzept: Übersichtsmodus
    timelineYears3: |-
      Im **Übersichtsmodus** zeigt die Timeline **Jahre** und **Monate** an. Jeder Monat wird durch eine kleine Linie gekennzeichnet.
      Sobald für ein Jahr Log-Einträge vorhanden sind, wird die Timeline für dieses Jahr gestreckt.

    timelineYears4_title: |-
      LOGBOOK Konzept: Übersichtsmodus
    timelineYears4: |-
      Rechts neben der Timeline erscheinen **Törns** mit Name und Zeitraum, und der betreffende **Zeitraum** ist farblich auf der Timeline markiert.

    timelineVoyageClick_title: |-
      LOGBOOK Konzept: Übersichtsmodus  
    timelineVoyageClick: |-
      Durch **Klicken auf einen Törn** wechselt LOGBOOK vom Übersichtsmodus zur Darstellung der ausgewählten Törns.

    timelineVoyage1_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage1: |-
      LOGBOOK zoomt in die Timeline und zeigt nur einen Ausschnitt der gesamten Timeline, der vom **ersten bis zum letzten Tag** des ausgewählten **Törns** reicht.

    timelineVoyage2_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage2: |-
      Jeder **Törn** kann eine Reihe von **Etappen** enthalten, wobei jede Etappe eine Reihe von **Tagen** enthalten kann. Alle Tage sind chronologisch entlang der Timeline aufgelistet.

    timelineVoyage3_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage3: |-
      der Button links neben dem Namen des Törns zeigt das **Datenblatt des Törns** an und blendet es wieder aus.

    timelineVoyage4_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage4: |-
      Das Datenblatt enthält mehrere Karten. Auf der Karte **Törn** kann dem Törn ein Name gegeben werden.

    timelineVoyage5_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage5: |-
      Die Karte **Statistik** bietet eine Zusammenfassung und Auswertung des Törns.

    timelineVoyage6_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage6: |-
      Die Karte **Track** zeigt den Track des gesamten Törns auf einer Seekarte. Auf der Karte **Törnplan** besteht die Möglichkeit, den Verlauf des Törns im Voraus zu planen.

    timelineVoyage7_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage7: |-
      Die **Schaltfläche oben rechts** im Törn-Bereich führt zurück zum Übersichtsmodus.

    timelineVoyage8_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage8: |-
      Und die Schaltfläche links schließt die Datenansicht des Törns.

    timelineVoyage9_title: |-
      LOGBOOK Konzept: Törn-Ansicht
    timelineVoyage9: |-
      Direkt unterhalb des Törn-Bereichs beginnt die erste **Etappe** des Törns.

    timelinePassage1_title: |-
      LOGBOOK Konzept: Die Etappe
    timelinePassage1: |-
      Alle **Tage der Etappe** werden entlang der Timeline angezeigt. Der Zeitraum, in dem das Schiff am jeweiligen Tag unterwegs war, ist farblich auf der Timeline hervorgehoben.

      Die Linien unterteilen den Tag in 4-Stunden-Abschnitte.

    timelinePassage2_title: |-
      LOGBOOK Konzept: Die Etappe
    timelinePassage2: |-
      Ein Klick auf den Pfeil links neben dem Namen zeigt das **Datenblatt der Etappe** mit mehreren Karten mit Daten, Einstellungen und Anzeigen.
      Hier ist die Karte **Statistik** mit einer Zusammenfassung und Auswertung der Etappe zu sehen.

    timelinePassage3_title: |-
      LOGBOOK Konzept: Die Etappe
    timelinePassage3: |-
      Ein Klick auf das **Datum eines Tages** öffnet den Tag.


    timelineDay1_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay1: |-
      Er erhält einen **farblich hervorgehobenen Header** und alle während des Tages aufgezeichneten **Log-Einträge** werden entlang der Timeline aufgelistet, die in diesem Bereich weiter gestreckt wird.

    timelineDay2_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay2: |-
      **Jede Stunde des Tages** ist durch eine **Linie** markiert, alle 4 Stunden etwas länger, und für 0:00 Uhr und 12:00 Uhr noch länger. So lässt sich auf einen Blick erkennen, wie die **Log-Einträge** über den Tag verteilt sind.

    timelineDay3_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay3: |-
      Der Pfeil im farbigen Header blendet anstelle der Liste der **Log-Einträge** das **Datenblatt des Tages** mit verschiedenen Karten ein.

    timelineDay4_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay4: |-
      Die Karte **Tag** ermöglicht die Eingabe von Informationen zum Tag, wie z.B. Crewmitglieder, Abfahrts- und Ankunftszeiten und mehr.

    timelineDay5_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay5: |-
      Einige Karten wie **Statistik**, **Track** und **Wetter** zeigen Auswertungen …

    timelineDay6_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay6: |-
      … andere wie **Journal** und **Technik** ermöglichen die Eingabe von individuellem Text und Fotos.

    timelineDay7_title: |-
      LOGBOOK Konzept: Der Tag
    timelineDay7: |-
      Schließen des Datenblatts des Tages mit der Umschaltfläche oben rechts im Datenblatt …,

    timelineLog1_title: |-
      LOGBOOK Konzept: Der Log-Eintrag
    timelineLog1: |-
      … führt zur Liste aller **Log-Einträge** des Tages zurück, der kleinsten Einheit in LOGBOOK.

    timelineLog2_title: |-
      LOGBOOK Konzept: Der Log-Eintrag
    timelineLog2: |-
      Der **Log-Eintrag** enthält NMEA-Daten und zusätzliche Informationen zu einem bestimmten Zeitpunkt.

    timelineLog3_title: |-
      LOGBOOK Konzept: Der Log-Eintrag
    timelineLog3: |-
      Ein Klick auf einen **Log-Eintrag** zeigt das **Datenblatt des Log-Eintrags** an.

    timelineLog4_title: |-
      LOGBOOK Konzept: Der Log-Eintrag
    timelineLog4: |-
      Der ausgewählte **Log-Eintrag** zeigt einen **farblich hervorgehobenen Header**. Im **Datenblatt des Log-Eintrags** werden die **automatisch erfassten Daten** angezeigt und beim aktuellen Log-Eintrag können weitere Daten eingegeben werden.

    timelineLog5_title: |-
      LOGBOOK Konzept: Der Log-Eintrag
    timelineLog5: |-
      Welche Felder nicht bearbeitbare, automatisch eingetragene Daten enthalten und welche Felder **manuelle Dateneingabe** erlauben, hängt von den **im NMEA vorhandenen Daten** ab.

    final1_title: |-
      LOGBOOK – Dein Begleiter auf See
    final1: |-
      **LOGBOOK** ist dein treuer Begleiter auf jedem Törn – immer an deiner Seite, vom ersten Log-Eintrag bis zum letzten.

      **LOGBOOK** begleitet dich durch jede Etappe, jeden Tag auf See, und hält die Geschichte deines Schiffes lebendig.

    final2_title: |-
      Erfahre mehr über **LOGBOOK**
    final2: |-
      Schaue dir unsere weiteren Screencasts an und erfahre mehr über den Einsatz von **LOGBOOK** in der täglichen Praxis. (Weitere Screencasts sind in Kürze verfügbar.)


  quickstart:
    title: |-
      LOGBOOK QuickStart – Einmalige Vorbereitungen 
    start: |-
      Dieser QuickStart hilft dir, **in wenigen Schritten mit LOGBOOK zu starten**. Es ist eine gekürzte Version des **QuickStart-Leitfadens** in unserer Dokumentation. Für detailliertere Anleitungen und Tipps schau dir diese bitte an.

    start1_title: |-  
      Login  
    start1: |-
      **Melde dich** in deinem Account in der **LOGBOOK Cloud** an unter 
      
      **https://logbook.yachts/app**.

    start2_title: |-  
      Login
    start2: |-
      Du bist jetzt in deinen persönlichen **Account-Einstellungen**. 
      
    start3_title: |-  
      Ersteinrichtung (einmalig)
    start3: |-
      Bevor du dein erstes Logbuch mit LOGBOOK führen kannst, sind zwei Schritte erforderlich (einmalig): 
      
      1 -  **Ein Schiff erstellen**.

      2 -  **Die Verbindung zum NMEA des Schiffes** oder zum integrierten GPS des Devices herstellen und analysieren.

    createShip_title: |-
      Schiff erstellen
    createShip: |-
      Zuerst benötigt LOGBOOK einige Informationen über dein **Schiff**, die die Grundkonfiguration des Logbuches beeinflussen. Daher wird beim ersten Start von LOGBOOK die Ansicht **Neues Schiff erstellen** angezeigt.
      
      Gib hier den **Schiffsnamen** ein, wähle den **Schiffstyp** (Segelboot/Motorboot) und lege die **Anzahl der Motoren** fest.

    createShip2_title: |-
      Schiff erstellen
    createShip2: |-
      Schließe dann die Ansicht mit der Schaltfläche **Schiff erstellen**. Das Schließen ist nur möglich, wenn alle drei Felder ausgefüllt sind.
      
    createShip3_title: |-
      Schiff erstellen
    createShip3: |-
      Verwende den Link unten im Text, um zur **LOGBOOK-App** zu wechseln.
      
    createShip4_title: |-
      Schiff erstellen
    createShip4: |-
      In der LOGBOOK-App siehst du nun die **Übersichts-Timeline** für dein Schiff. 
      
      Im **Schiffbereich** werden der Schiffstyp und der Schiffsname sowie einige Schaltflächen angezeigt. Alle zusätzlichen Informationen über das Schiff können jederzeit später in der Ansicht **Schiffsdaten** eingegeben werden.

      In dieser Demo wurden MMSI und Rufzeichen bereits eingegeben.
      
    connectNMEA_title: |-
      NMEA-Verbindung einrichten
    connectNMEA: |-
      Schalte zunächst dein **NMEA-Netzwerk** oder GPS ein und **verbinde dein Device** mit dem NMEA-Netzwerk/GPS. 

    connectNMEA2_title: |-
      NMEA-Verbindung einrichten
    connectNMEA2: |-
      Das Device, das mit dem NMEA verbunden ist, wird als **Primary Device** mit dem **Primary LOGBOOK** bezeichnet. Das Primary LOGBOOK ist das Hauptlogbuch, das die NMEA-Daten empfängt und Log-Einträge erstellt. 

    connectNMEA3_title: |-
      NMEA-Verbindung einrichten
    connectNMEA3: |-
      Wähle nun **Einstellungen** aus dem Menü der **NMEA**-Schaltfläche (rechts im Schiffbereich). Wenn noch keine Verbindung eingerichtet wurde, zeigt die Schaltfläche einen roten Marker <span style="color: var(--red); font-size: 1.5em;">□</span>.   

    connectNMEA4_title: |-
      NMEA-Verbindung einrichten
    connectNMEA4: |-
      Gehe auf der ersten Karte des Dialogs zu **NMEA-Verbindungstyp** und wähle aus, welches Protokoll oder welcher Verbindungstyp das NMEA-Netzwerk mit deinem Device verbindet (**USB** oder WiFi/Ethernet mit **TCP**). 
      
      Wenn du wählen kannst, wie du dein NMEA mit deinem Device verbindest: TCP ist besser als USB.  

    connectNMEA5_title: |-
      NMEA-Verbindung einrichten
    connectNMEA5: |-
      Nimm dann die Einstellungen in den zusätzlichen Feldern vor, die für den Verbindungstyp angezeigt werden (Adresse, Port usw.). Die erforderlichen Daten findest du in der Dokumentation des Gateways, Multiplexers oder Plotters. Für **USB** werden die verfügbaren Geräte unter **Geräte** aufgelistet.

      Wenn dein Device ein **integriertes GPS** hat, gibt es eine zusätzliche Option.

    connectNMEA6_title: |-
      Verbindung testen
    connectNMEA6: |-
      Verwende die Schaltfläche **Verbindung testen**, um zur nächsten Karte des Dialogs zu wechseln und den Test der Verbindung zu starten. 
      
    connectNMEA7_title: |-
      Verbindung testen
    connectNMEA7: |-
      LOGBOOK startet den **Datenabruf** über die auf der ersten Karte des Dialogs eingestellte Verbindung. Es kann einen Moment dauern, bis die **ersten Daten empfangen** werden. 

    connectNMEA8_title: |-
      Verbindung testen
    connectNMEA8: |-
      Wenn mindestens **UTC** und **GPS-Position** einen grünen Punkt auf der Karte **Test und Daten** zeigen, kannst du den Dialog mit **Abschließen** schließen.  

    connectNMEA9_title: |-
      Verbindung testen
    connectNMEA9: |-
      Der grüne, nicht ausgefüllte Marker <span style="color: var(--green); font-size: 1.5em;">□</span> im **NMEA Button** sowie der orange Punkt  <span style="color: var(--orange); font-size: 1.5em; vertical-align: bottom;">●</span> beim Menüeintrag **Automatisches Loggen** zeigen, dass die Verbindung zum NMEA-Netzwerk hergestellt ist und **Daten empfangen werden**, aber noch keine regelmäßigen automatischen Log-Einträge erstellt werden.  

      Nun sind die einmaligen Vorbereitungen abgeschlossen und du bist bereit, deine **erste Fahrt** zu starten und dein erstes Logbuch mit LOGBOOK zu führen.  

    final2_title: |-
      Erfahre mehr über **LOGBOOK**
    final2: |-
      Schaue dir unsere weiteren Screencasts an und erfahre mehr über den Einsatz von **LOGBOOK** in der täglichen Praxis. (Weitere Screencasts sind in Kürze verfügbar.)


  quickstartVoyage:
    startVoyage_title: |-
      LOGBOOK QuickStart – Starte deine erste Fahrt
    startVoyage: |-
      Dieser QuickStart zeigt dir, wie du deine **erste Fahrt** mit LOGBOOK aufzeichnest. Es ist eine gekürzte Version des **QuickStart-Leitfadens** in unserer Dokumentation. Für detailliertere Anleitungen und Tipps schau dir diese bitte an.

    startPassage_title: |-
      Fahrt starten
    startPassage: |-
      Wechsle mit dem **Fokus-Button** oben im **Schiffbereich** oder mit dem **Fokus-Button** in der Timeline zur **Fokusansicht**. Die Fokusansicht ist die Ansicht für die Bearbeitung während der Fahrt. Einträge im Datenblatt **Tag** und in den **Log-Einträgen** können nur in der Fokusansicht vorgenommen werden.        

    startPassage2_title: |-
      Fahrt starten
    startPassage2: |-
      Beim ersten Start von LOGBOOK sind bereits eine **erster Törn** und eine **erste Etappe** vorbereitet, damit du so schnell wie möglich mit der Datenaufzeichnung beginnen kannst.   

    startPassage3_title: |-
      Fahrt starten
    startPassage3: |-
      LOGBOOK verwendet für die Zeitzone der **Bordzeit** automatisch die Systemzeitzone des **Primary Device**. Wenn du für die Fahrt eine andere Zeitzone verwenden möchtest, kannst du diese in den **Schiffseinstellungen** festlegen. Zur Orientierung wird hier zusätzlich zur Zeitzone auch die zugehörige **aktuelle Schiffszeit** angezeigt. 

    startPassage4_title: |-
      Fahrt starten
    startPassage4: |-
      Gib einen Namen für die Etappe ein und starte die Etappe mit der Schaltfläche **Etappe starten**. 

    startPassage5_title: |-
      Fahrt starten
    startPassage5: |-
      In der **Fokusansicht** konzentriert sich die Bildschirmanzeige auf den **aktuellen Tag** und die **Log-Zeile**, die farbig hervorgehobene Zeile direkt unter dem letzten Log-Eintrag. Die Log-Zeile zeigt die **aktuell aus dem NMEA gelesenen Werte** an. 

    dayData_title: |-
      Daten für den Tag eingeben
    dayData: |-
      Vor dem Ablegen solltest du einige wichtige Daten auf dem **Datenblatt Tag** auf der Karte **Tag** eingeben. Dies sind der **Startort**, der **Skipper** und die Personen in der **Crew** und die **Passagiere**, falls zutreffend. Die Personen müssen am aktuellen Tag eingetragen werden, da sie für die Nachweisführung relevant sind.  

    dayData2_title: |-
      Daten für den Tag eingeben
    dayData2: |-      
      Für **Skipper**, **Crew** und **Passagiere** kannst du Personen aus deiner Liste aller Personen auswählen. Bei einem neuen, leeren Logbuch ist die Personenliste noch leer. Personen können jedoch während der Eingabe einfach **erstellt werden**, indem der Eintrag **Person hinzufügen** oben in der Auswahlliste verwendet wird. 

    engine1_title: |-
      Ablegen
    engine1: |-      
      Starte deine Motoren. Wenn dein NMEA **Motordaten** enthält, erkennt LOGBOOK automatisch, wann ein Motor ein- oder ausgeschaltet wird, und erstellt einen Log-Eintrag für dieses Ereignis. Der Status des Motors wird im Log-Eintrag mit den Motor-Schaltflächen angezeigt.  

    engine2_title: |-
      Ablegen
    engine2: |-      
      Der zweite Motor läuft nun.    

    departing_title: |-
      Ablegen
    departing: |-      
      LOGBOOK **erfasst und analysiert nun alle 30 Sekunden NMEA-Daten**. Sobald sich das **Schiff in Bewegung setzt**, erstellt LOGBOOK automatisch den **ersten Log-Eintrag** und der links von der Timeline angezeigte Schiffsstatus ändert sich auf **<span class="LogbookIcon-status-inmotion"></span> In Fahrt**. 

    departing2_title: |-
      Ablegen
    departing2: |-      
      Nach dem Ablegen ist der **NMEA-Button** grüner gefüllt und der Menüeintrag **Automatisches Loggen** zeigt einen grünen Punkt <span style="color: var(--green); font-size: 1.5em;">●</span>. Das bedeutet, dass die automatischen Log-Einträge jetzt aktiv sind. 
      
    logEntries2_title: |-
      Automatisches Loggen
    logEntries2: |-      
      Während der Fahrt erstellt LOGBOOK **jede volle** oder **halbe Stunde** einen **Log-Eintrag** (je nach ausgewählter Einstellung). LOGBOOK erkennt, ob sich das Schiff **bewegt oder nicht** und **erstellt automatisch einen Eintrag** sowohl beim Ablegen als auch beim Stoppen. 

    entry_30min_title: |-
      Automatisches Loggen
    entry_30min: |-      
      Während der Fahrt erstellt LOGBOOK **jede volle** oder **halbe Stunde** einen **Log-Eintrag** (je nach ausgewählter Einstellung).

    manualEntry_title: |-
      Manuelle Log-Einträge
    manualEntry: |-      
      Unabhängig von den im Dialog **NMEA-Einstellungen** auf der Karte **Bedingungen** ausgewählten Bedingungen für automatische Log-Einträge kann jederzeit mit dem **+ Log-Button** **links von der Log-Zeile** ein Log-Eintrag **manuell** ausgelöst werden. Ein Klick auf den Button erstellt einen Log-Eintrag mit den **aktuellen NMEA-Daten** und dem **aktuellen Schiffsstatus**.

    manualEntry1a_title: |-
      Manuelle Log-Einträge
    manualEntry1a: |-      
      Für manuelle Log-Einträge mit häufig verwendeten Optionen klicken Sie auf den **Pfeil-Button**, um das Menü zu öffnen.

    manualEntry1b_title: |-
      Manuelle Log-Einträge
    manualEntry1b: |-      
      Das Menü zeigt verschiedene Optionen für manuelle Log-Einträge. **Manuelle Log-Einträge** sind beispielsweise nützlich, wenn **Segel** gesetzt oder geborgen werden oder wenn eine **Beobachtung** notiert werden soll.

    sail_entry1_title: |-
      Manuelle Log-Einträge
    sail_entry1: |-      
      Wählen Sie den **Großsegel**-Button, um das Setzen des Großsegels zu dokumentieren.

    sail_entry2_title: |-
      Manuelle Log-Einträge – Segel
    sail_entry2: |-      
      Nach der Auswahl von **Großsegel** erscheint der Button **Segel speichern**. Klicken Sie darauf, um die Segeländerung zu speichern und den Log-Eintrag zu erstellen.

    sail_entry3_title: |-
      Manuelle Log-Einträge
    sail_entry3: |-      
      **Großsegel** und **Genua** wurden gesetzt.  

      Der **Kommentartext** in der Kopfzeile des Log-Eintrags wird automatisch basierend auf den ausgewählten Segeln generiert.

    selectSail2_title: |-
      Manuelle Log-Einträge – Segel
    selectSail2: |-      
      Klicken Sie auf **Segel speichern**, um die Segelauswahl zu bestätigen und den Log-Eintrag zu erstellen.

    selectSail3_title: |-
      Manuelle Log-Einträge – Segel
    selectSail3: |-      
      Die Segeländerungen werden gespeichert...

    selectSail4_title: |-
      Manuelle Log-Einträge
    selectSail4: |-      
      Die Segeländerung wurde aufgezeichnet. Der Log-Eintrag zeigt, welche Segel gesetzt wurden.

    logEntries3_title: |-
      Automatisches Loggen
    logEntries3: |-      
      Wenn die NMEA-Daten **Motordaten** enthalten, wird auch jedes Mal ein Eintrag erstellt, wenn ein **Motor ein- oder ausgeschaltet** wird. 

    logEntries4_title: |-
      Ergänzungen in den Log-Einträgen
    logEntries4: |-      
      Um einen Log-Eintrag zu ergänzen, klicke auf die Zeile des Eintrags. Die möglichen Informationen sind auf **3 Karten** verteilt. Felder mit automatisch erfassten Daten können nicht bearbeitet werden. Bearbeitbare Felder sind leicht an der Hervorhebung des Feldbereichs zu erkennen. Automatische Log-Einträge können **maximal 60 Minuten lang** ergänzt werden, solange es keinen neuen automatischen Log-Eintrag gibt.
 
    logEntries5_title: |-
      Ergänzungen in den Log-Einträgen
    logEntries5: |-      
      Zusätzlich zu den automatisch über NMEA erfassten Daten kann jeder Log-Eintrag auch einige Informationen enthalten, die nicht im NMEA enthalten sind, zum Beispiel Änderungen an den **Segeln** und ein **Kommentar** sowie **Wetterbeobachtungen**. All dies musst du manuell eingeben. 

    logEntries6_title: |-
      Ergänzungen in den Log-Einträgen
    logEntries6: |-      
      Auf der Karte **Umgebung** kannst du Beobachtungen zu **Wetter**, **Seegang** und **Strömungen**, **Lufttemperatur** und mehr dokumentieren. 
 
    logEntries7_title: |-
      Automatisches Loggen
    logEntries7: |-      
      Wenn im Dialog **NMEA-Einstellungen** auf der Karte **Bedingungen** aktiviert, erstellt LOGBOOK automatisch Log-Einträge für Kursänderungen. 
 
    manualEntry3_title: |-
      Manueller Log-Eintrag für Motorstatus
    manualEntry3: |-      
      Wenn das NMEA keine **Motordaten** enthält, sollte immer ein **manueller Log-Eintrag** erstellt werden, wenn ein **Motor ein- oder ausgeschaltet** wird. Verwende die **Motor-Schaltflächen** in der Log-Zeile, um den Status des Motors zu ändern und einen **manuellen Log-Eintrag** zu erstellen. Das Symbol auf der Schaltfläche zeigt den **aktuellen Motorstatus** an.       

    manualEntry4_title: |-
      Manueller Log-Eintrag für Motorstatus
    manualEntry4: |-      
      Im manuellen Log-Eintrag können dann auch die **Drehzahlen** für jeden Motor eingegeben werden. 

    logEntries8_title: |-
      Automatisches Loggen
    logEntries8: |-      
      Genieße das Segeln, während LOGBOOK **automatisch Log-Einträge** für dich erstellt. Wann immer erforderlich oder gewünscht, kannst du **zusätzliche Informationen** hinzufügen oder **manuelle Log-Einträge** erstellen.

    endDay_title: |-
      Tagesende
    endDay: |-      
      Immer wenn sich das Schiff für eine bestimmte Zeit nicht bewegt hat, erscheint in der Log-Zeile der **Stopp-Button**.            
  
    endDay2_title: |-
      Tagesende
    endDay2: |-      
      Der **Stopp-Button** öffnet einen Dialog, in dem du den Stopp als Zwischenstopp aufzeichnen oder die Fahrt und damit den Tag beenden kannst. 
        
    endDay3_title: |-
      Tagesende
    endDay3: |-            
      Um den Tag zu beenden, wähle die Option **Tagesende**. Gib dann den Namen deines **aktuellen Standorts** ein. Wähle aus, ob du am **Ankerplatz** liegst, im **Hafen** bist usw.  
      
    endDay4_title: |-
      Tagesende
    endDay4: |-      
      Nach dem Schließen des Dialogs wird das Symbol für den **ausgewählten Schiffsstatus** in der Zeile des Log-Eintrags angezeigt. LOGBOOK ändert den **Schiffsstatus** des Log-Eintrags, der automatisch **beim Stoppen erstellt** wurde. Dies gibt dir die Möglichkeit, Details für diesen Eintrag später zu erfassen.          
  
    endDay5_title: |-
      Tagesende
    endDay5: |-      
      Mit der Auswahl von **Tagesende** wird der LOGBOOK-Tag beendet. LOGBOOK **deaktiviert die automatischen Log-Einträge** und du kannst jetzt, wenn gewünscht, dein NMEA-Netzwerk ausschalten und die LOGBOOK-App schließen. Dann wird das **Ausschalten der Datenaufzeichnung** in einem **Log-Eintrag** dokumentiert (ohne NMEA-Daten).           

    endDay6_title: |-
      Tagesende
    endDay6: |-      
      Wenn die **Datenaufzeichnung ausgeschaltet ist**, zeigen der Menüpunkt **NMEA-Verbindung** und auch der NMEA-Button einen orange Marker <span style="color: var(--orange); font-size: 1.5em;">●</span>, der Marker auf dem Menü-Button ist orange und nicht ausgefüllt <span style="color: var(--orange); font-size: 1.5em;">□</span>. Die Option Automatisches Loggen ist deaktiviert. 

    endDay7_title: |-
      Tagesende
    endDay7: |-      
      Wenn du die **NMEA-Verbindung aktiv** hältst und später oder am nächsten Tag wieder losfährst, wird LOGBOOK das **Ablegen erkennen** und dokumentieren und automatisch wieder Log-Einträge erstellen wie zuvor.   
      
    nextDay_title: |-
      Der nächste Tag
    nextDay: |-      
      Der neue Tag ist bereits vorbereitet. Auf der Karte **Tag** ist alles so ausgefüllt wie am Vortag, und der **Startort** ist das Ziel des Vortags. Bei Bedarf kannst du noch Änderungen an der Crew usw. vornehmen.   
  
    nextDay2_title: |-
      Der nächste Tag
    nextDay2: |-      
      Am nächsten Tag ist alles zum Starten bereit. Egal, ob du die LOGBOOK-App geschlossen und wieder geöffnet hast oder sie die ganze Zeit geöffnet war, wenn die **NMEA-Datenquelle** **eingeschaltet** ist, kannst du sofort mit den **Log-Einträgen** für den neuen Tag fortfahren.   

    nextDay3_title: |-
      Der nächste Tag
    nextDay3: |-      
      LOGBOOK **verbindet sich automatisch wieder** mit dem **NMEA** nach dem Schließen der App und/oder dem Ausschalten der NMEA-Datenquelle und sucht regelmäßig nach NMEA-Daten. Sobald die Verbindung wiederhergestellt werden kann, **zeigt der NMEA-Button wieder grün** an. 
      
      Wenn der Marker der Schaltfläche orange bleibt, musst du den **NMEA-Verbindungsschalter** aus dem **NMEA-Menü** erneut aktivieren.   

    nextDay4_title: |-
      Der nächste Tag
    nextDay4: |-      
      Und sobald sich das **Schiff wieder in Bewegung setzt**, werden **automatische Log-Einträge** gestartet, und am Ende der Fahrt können die erforderlichen Schritte zum Beenden des Tages und der automatischen Log-Einträge erneut im **Stopp-Dialog** durchgeführt werden.   

    final2_title: |-
      Erfahre mehr über LOGBOOK
    final2: |-
      Schaue dir unsere weiteren Screencasts an und erfahre mehr über den Einsatz von **LOGBOOK** in der täglichen Praxis. (Weitere Screencasts sind in Kürze verfügbar.) 

ui:
  previous: Zurück
  next: Weiter
  start_image: /demo/Title-Concept-de.svg
  start_solo_image: /demo/Start.svg
  quickstartChapter: |-
    QuickStart – Vorbereitungen
  quickstartChapter2: |-
    QuickStart – Erste Fahrt  